// mesbot/src/institution/InstitutionSidebar.js
import React from "react";
import {
  FiGrid, FiActivity, FiUsers, FiSettings, FiLogOut
} from "react-icons/fi";

const NAV_ITEMS = [
  { id: "overview",  label: "Overview",  icon: FiGrid,     roles: ["admin", "counselor"] },
  { id: "wellness",  label: "Wellness",  icon: FiActivity, roles: ["admin", "counselor"] },
  { id: "students",  label: "Students",  icon: FiUsers,    roles: ["admin"] },
  { id: "settings",  label: "Settings",  icon: FiSettings, roles: ["admin"] },
];

export default function InstitutionSidebar({ user, activePage, setActivePage, onLogout }) {
  const initials = (user.institutionName || "R")
    .split(" ").slice(0, 2).map(w => w[0]).join("").toUpperCase();

  return (
    <nav className="inst-sidebar">
      <div className="inst-sidebar-logo">
        Rigby
        <div className="inst-sidebar-subtitle">Institutional Dashboard</div>
      </div>

      {NAV_ITEMS.filter(item => item.roles.includes(user.role)).map(item => (
        <button
          key={item.id}
          className={`inst-nav-item ${activePage === item.id ? "active" : ""}`}
          onClick={() => setActivePage(item.id)}
        >
          <item.icon size={15} />
          {item.label}
        </button>
      ))}

      <div className="inst-sidebar-user">
        <div className="inst-avatar">{initials}</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="inst-avatar-name" style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {user.institutionName}
          </div>
          <div className="inst-avatar-role">{user.role}</div>
        </div>
        <button
          onClick={onLogout}
          style={{ background: "none", border: "none", cursor: "pointer", color: "#6b7280", padding: 4 }}
          title="Sign out"
        >
          <FiLogOut size={14} />
        </button>
      </div>
    </nav>
  );
}
